export const confirmModalConstants = {
    OPEN_CONFIRM_MODAL: 'OPEN_CONFIRM_MODAL',
    CLOSE_CONFIRM_MODAL: 'CLOSE_CONFIRM_MODAL'
};